import workspaceQuery from '../../../graphql/queries/supplier/SupplierNoteTypeWorkspaceQuery.graphql';
import listQuery from '../../../graphql/queries/supplier/SupplierNoteTypeListQuery.graphql';
import instanceQuery from '../../../graphql/queries/supplier/SupplierNoteTypeQuery.graphql';
import defaultQuery from '../../../graphql/queries/supplier/SupplierNoteTypeDefault.graphql';
import mutationQuery from '../../../graphql/mutations/supplier/SupplierNoteTypeMutation.graphql';
import fragment from '../../../graphql/fragments/supplier/SupplierNoteTypeFragment.graphql';
import { Direction } from '../../schema/p4types';
import { EntityType } from '../../../@types/entityTypes';

const SupplierNoteType: EntityType = {
  type: 'SupplierNoteType',
  title: 'Supplier Note Types',
  formTitle: 'Supplier Note Type',
  formUrl: '/Suppliers/NoteType/Details/',
  workspaceUrl: '/Suppliers/NoteType/Workspace/',
  instance: instanceQuery,
  workspace: workspaceQuery,
  default: defaultQuery,
  update: mutationQuery,
  dropdown: {
    query: listQuery,
    valueKey: 'id',
    labelKey: 'title',
    customVariables: () => {
      return {
        orderBy: 'title',
        orderDirection: Direction.Asc,
      };
    },
  },
  fragment,
  screenReference: 'SUPPLIERS_NOTE_TYPES',
};

export default SupplierNoteType;
